export enum EReservationServiceGroupID {
	CAR_RENT = 1,
	ADDITIONAL_EQUIPMENT = 2,
	PAYMENTS = 3,
	INSURANCE = 5,
}

export enum EReservationServiceTypeID {
	CAR_RENT = 1,
	ADDITIONAL_EQUIPMENT = 2,
	ADDITIONAL_PAYMENT = 3,
	INSURANCE = 7,
	ONE_WAY_FEE = 10,
}

export enum ERenteonServiceCode {
	// both ADF and ADD relate to additional drivers; only ADF is selectable in the UI
	ADDITIONAL_DRIVER = 'ADF',
	ADDITIONAL_DRIVER_FEE = 'ADD',
	VEHICLE_DELIVERY = 'VEH-DEL',
	VEHICLE_COLLECTION = 'VEH-COL',
	LOCATION_DELIVERY = 'LDD',
	LOCATION_COLLECTION = 'LDC',
	NIGHT_HOURS_RELEASE = 'OHD',
	NIGHT_HOURS_COLLECTION = 'OHDD',
	PREPARATION_FEE = 'OP-PF',
	CAR_WASH = 'PR-DC',
	CAR_WASH_BUS = 'PR-DC-BUS',
	GPS = 'GPS',
	CHILD_SEAT_0_9 = 'CS0-9',
	CHILD_SEAT_9_36 = 'CS09-36',
	BOOSTER_SEAT = 'CSPAD',
	ABROAD_ZONE_1 = 'TOC-Z1',
	ABROAD_ZONE_2 = 'TOC-Z2',
	ABROAD_ZONE_3 = 'TOC-Z3',
}

interface IRenteonServiceMeta {
	icon: string
	isAbroadZone?: boolean
}

export const DEFAULT_SERVICE_ICON = 'car'

export const RENTEON_SERVICE_META: Partial<Record<ERenteonServiceCode, IRenteonServiceMeta>> = {
	[ERenteonServiceCode.GPS]: { icon: 'gps' },
	[ERenteonServiceCode.CHILD_SEAT_0_9]: { icon: 'child-seat-0-9' },
	[ERenteonServiceCode.CHILD_SEAT_9_36]: { icon: 'child-seat-9-36' },
	[ERenteonServiceCode.BOOSTER_SEAT]: { icon: 'child-underseat' },
	[ERenteonServiceCode.CAR_WASH]: { icon: 'car-shiny' },
	[ERenteonServiceCode.CAR_WASH_BUS]: { icon: 'car-shiny' },
	[ERenteonServiceCode.ADDITIONAL_DRIVER]: { icon: 'user-add' },
	[ERenteonServiceCode.ADDITIONAL_DRIVER_FEE]: { icon: 'user-add' },
	[ERenteonServiceCode.ABROAD_ZONE_1]: { icon: 'earth', isAbroadZone: true },
	[ERenteonServiceCode.ABROAD_ZONE_2]: { icon: 'earth', isAbroadZone: true },
	[ERenteonServiceCode.ABROAD_ZONE_3]: { icon: 'earth', isAbroadZone: true },
}

// services managed by dedicated UI (delivery/collection in booker, additional driver counter), excluded from the addons list
export const ADDON_EXCLUDED_SERVICE_CODES: ERenteonServiceCode[] = [
	ERenteonServiceCode.VEHICLE_DELIVERY,
	ERenteonServiceCode.VEHICLE_COLLECTION,
	ERenteonServiceCode.ADDITIONAL_DRIVER,
]
